import { useConfigStore } from '@/client/services/state/configStore';

// TODO: Mutation to save selection to user

export const useLearnerDashboardHeroImage = () => {
  const { config } = useConfigStore();
  const { publicImageUrl } = config;

  const rootUrl = `${publicImageUrl}continu/dashboard-hero-images/`;

  const imageOptions = [
    [
      'Purple-1.jpg',
      'Purple-2.jpg',
      'Purple-3.jpg',
      'Orange-1.jpg',
      'Orange-2.jpg',
      'Orange-3.jpg',
      'Blue-1.jpg',
      'Blue-2.jpg',
      'Blue-3.jpg',
      'Green-1.jpg',
      'Green-2.jpg',
      'Green-3.jpg',
      'Yellow-1.jpg',
      'Yellow-2.jpg',
      'Yellow-3.jpg',
      'Red-1.jpg',
      'Red-2.jpg',
      'Red-3.jpg',
    ],
    [
      'Watercolor-1.jpg',
      'Watercolor-2.jpg',
      'Watercolor-3.jpg',
      'Bubbles.jpg',
      'Rainbow.jpg',
      'Swirls.jpg',
    ],
    [
      'Abstract-7.jpg',
      'Abstract-8.jpg',
      'Abstract-9.jpg',
      'Abstract-10.jpg',
      'Abstract-11.jpg',
      'Abstract-12.jpg',
    ],
  ].map((images) => images.map((image) => `${rootUrl}${image}`));

  return { imageOptions };
};
